var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecording(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.75,
    height: 15.469,
    viewBox: "0 0 33.75 15.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-recording",
    "data-name": "Icon ionic-ios-recording",
    d: "M27.155,10.266h-.007A7.741,7.741,0,0,0,21.7,23.484h-7.39A7.741,7.741,0,0,0,8.859,10.266H8.845a7.734,7.734,0,0,0,0,15.469H27.155a7.734,7.734,0,0,0,0-15.469ZM32.625,18a5.477,5.477,0,1,1-5.477-5.5A5.493,5.493,0,0,1,32.625,18ZM8.852,23.5A5.5,5.5,0,1,1,14.33,18,5.5,5.5,0,0,1,8.852,23.5Z",
    transform: "translate(-1.125 -10.266)",
    fill: "#527991"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecording);
export default __webpack_public_path__ + "static/media/recording.3fe07d46.svg";
export { ForwardRef as ReactComponent };